<template>
  <div class='c-outer-div h-100'>
    <v-container grid-list-xl fluid>
      <v-card class='mb-3'>
        <v-card-text>
          <v-row align='center'>
            <v-col cols='12' md='2' lg='2'>
              <h3>Google Calendar events from date:</h3>
            </v-col>
            <v-col cols='12' md='3' lg='3'>
              <RangeDatePickerMenu
                v-model="dates"
                showButtons
              />
            </v-col>
            <v-col cols="12" md="2" lg="2">
              <v-btn
                :disabled='dates.length !== 2'
                small
                color='primary'
                @click='transferData'
              >
                View from selected interval
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols='12' md='2' lg='2'>
              <v-tooltip v-if="!endOrStartOfYear" top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-btn
                      :disabled="!endOrStartOfYear"
                      color="success"
                      small
                      @click.prevent="createNewTasks"
                    >
                      Create new absence tasks
                    </v-btn>
                  </span>
                </template>
                <span>Available only in December and January.</span>
              </v-tooltip>

              <v-btn
                v-else
                :disabled="!endOrStartOfYear"
                color="success"
                small
                @click.prevent="createNewTasks"
              >
                Create new absence tasks
              </v-btn>
            </v-col>
            <v-col class="d-flex align-center" cols="12" md="2" lg="2">
              <v-row align="center" justify="end">
              <h3>Sick-leaves mode</h3>
              <v-switch
                v-model="sickLeavesMode"
                class="pl-4">
              </v-switch>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <template v-if='dataRetrieved'>
        <v-row class='fill-height'>
          <v-col>
            <v-sheet height='64'>
              <v-toolbar flat>
                <v-btn
                  class='mr-4'
                  small
                  color='primary'
                  @click='setToday'
                >
                  Today
                </v-btn>
                <v-btn class="mr-2" icon small @click='prev'>
                  <v-icon> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn class="mr-2" icon small @click='next'>
                  <v-icon> mdi-chevron-right </v-icon>
                </v-btn>
                <v-toolbar-title v-if='$refs.calendar'>
                  {{ $refs.calendar.title }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-menu bottom right>
                  <template v-slot:activator='{ on, attrs }'>
                    <v-btn
                      small
                      color='primary'
                      v-bind='attrs'
                      v-on='on'
                    >
                      <span>{{ typeToLabel[type] }}</span>
                      <v-icon right> mdi-menu-down </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                  <v-list-item @click="type = 'day'">
                    <v-list-item-title>Day</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'week'">
                    <v-list-item-title>Week</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'month'">
                    <v-list-item-title>Month</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = '4day'">
                    <v-list-item-title>4 days</v-list-item-title>
                  </v-list-item>
                </v-list>
                </v-menu>
              </v-toolbar>
            </v-sheet>
            <v-sheet height='800'>
              <v-calendar
                ref='calendar'
                v-model='focus'
                color='primary'
                :events='events'
                :event-color='getEventColor'
                :type="type"
                @click:event="showEvent"
                @click:more="viewDay"
                @click:date="viewDay"
                :key="updateKey"
              ></v-calendar>
              <v-menu
                v-model='selectedOpen'
                :close-on-content-click='false'
                :activator='selectedElement'
                max-width='600px'
                offset-x
              >
                <v-card color='grey lighten-4' min-width='450px' flat>
                  <v-toolbar :color='selectedEvent.color' dark>
                    <v-toolbar-title>
                      {{ selectedEvent.name }}
                    </v-toolbar-title>
                  </v-toolbar>
                      <v-card-text>
                    <v-text-field
                      :disabled='selectedEvent.color === "red"'
                      v-model='selectedEvent.name'
                      @keyup='checkForChanges(selectedEvent)'
                    >
                    </v-text-field>
                    <v-menu
                      v-model='menuSelected'
                      :close-on-content-click='false'
                      transition='scale-transition'
                      offset-y
                      min-width='auto'
                    >
                      <template v-slot:activator='{ on, attrs }'>
                        <v-text-field
                          v-model='intervalForPickerMenu'
                          label='Choose interval'
                          prepend-icon='mdi-calendar'
                          readonly
                          v-bind='attrs'
                          v-on='on'
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        @keyup='checkForChanges(selectedEvent)'
                        v-if='!selectedEvent.timed'
                        v-model='selectedEvent.eventDates'
                        :min='getDateWithMonthOffset(-3)'
                        :max='getDateWithMonthOffset(3)'
                        :first-day-of-week='1'
                        :disabled='selectedEvent.color === "red"'
                        range
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          small
                          color="primary"
                          outlined
                          @click="menuSelected = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          small
                          color="primary"
                          @click='onClickSelectedDate(selectedEvent)'
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                      <v-col
                        v-else
                        style="width: 300px; flex: 0 1 auto;">
                      <h2>Start time:</h2>
                      <v-time-picker
                        :disabled='selectedEvent.color === "red"'
                        v-model="startDateForTimePicker"
                        max="17:00"
                      ></v-time-picker>
                      </v-col>
                    </v-menu>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn small color='primary' @click='selectedOpen = false'>
                      OK
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-sheet>
          </v-col>
        </v-row>
        <v-dialog v-model='showDialog' max-width='290'>
          <v-card>
            <v-card-title>Transfer absence events?</v-card-title>
            <v-card-actions>
              <v-btn small outlined width="6.5em" color='primary' @click='showDialog = false'>
                Cancel
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn small color='primary' @click='submitTransmission'>
                Transfer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-overlay
          :absolute="true"
          :value="isLoading"
        >
          <v-progress-circular
            indeterminate
            size="256"
          ></v-progress-circular>
        </v-overlay>
        <v-dialog v-model='showWarningDialog' max-width='500'>
          <v-card>
            <v-card-title>
              Chosen period include closed summaries
              <v-spacer></v-spacer>
              <v-btn
                icon
                @click.prevent="showWarningDialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row justify="center" class="mt-2">
                <h3 class="black--text">Summaries:</h3>
              </v-row>
              <v-row class="mt-0">
                <h4 class="black--text" v-for="item in lastSummaryDates" :key="item.From_Date"><br>
                  {{item.Project_Name}} : {{formatLocalDate(item.From_Date)}} - {{formatLocalDate(item.To_Date)}}
                </h4>
              </v-row>
              <v-row class="mt-1">
                <h3 class="mt-3 black--text"> Please choose another period to import! </h3>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color='primary' @click='showWarningDialog = false'>
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-col class='text-right'>
          <v-btn small class='ma-2' color='primary' @click='getClosedSummaryState'>
            Transfer to DCM
          </v-btn>
        </v-col>
      </template>
      <span class='caption-1' v-else-if='!isLoading'>
        Choose appropriate interval and click on button
      </span>
      <v-overlay
        :absolute="true"
        :value="isLoading && !dataRetrieved"
      >
        <v-progress-circular
          indeterminate
          size="128"
        ></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
import { formatLocalDate } from '@/utils/dateUtils'

export default {
  name: 'Vacations',
  components: {
    RangeDatePickerMenu: () => import('@/components/global/RangeDatePickerMenu.vue')
  },
  data () {
    return {
      updateKey: 0,
      showDialog: false,
      focus: '',
      type: 'month',
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
        '4day': '4 Days'
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      date: new Date(),
      menu: false,
      menuSelected: false,
      dataRetrieved: false,
      sickLeavesMode: false,
      dates: [],
      originalEvents: [],
      lastSummaryDates: [],
      showWarningDialog: false,
      dateForAbsenceAndSickLeaveTasks: new Date().getFullYear(),
      isLoading: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    getStartDate () {
      return this.getDateWithMonthOffset(-3)
    },
    getEndDate () {
      return this.getDateWithMonthOffset(3)
    },
    startDateForTimePicker: {
      get () {
        return this.selectedEvent.start.slice(11, 19)
      },
      set (val) {
        const dateTimeWithoutTime = this.selectedEvent.start.slice(0, 10)
        this.selectedEvent.start = dateTimeWithoutTime + ' ' + val + ':00'
        const endDate = new Date(this.selectedEvent.start)
        endDate.setHours(endDate.getHours() + 4)
        this.selectedEvent.end = this.convertDateToString(endDate)
        this.checkForChanges(this.selectedEvent)
      }
    },
    intervalForPickerMenu () {
      if (this.selectedEvent.timed) {
        return [this.selectedEvent.start.slice(11, 19), this.selectedEvent.end.slice(11, 19)]
      }
      return this.selectedEvent.eventDates
    },
    endOrStartOfYear () {
      const currentMonth = new Date().getMonth()

      const isLastOrFirstMonth = (() => {
        return currentMonth === 11 || currentMonth === 0
      })()
      return isLastOrFirstMonth
    }
  },
  methods: {
    submitTransmission () {
      this.isLoading = true
      this.showDialog = false
      const eventsToConsider = []
      for (let i = 0; i < this.events.length; ++i) {
        if (this.events[i].color === 'purple') {
          if (this.originalEvents[i].color === 'blue') {
            const copied = Object.assign({}, this.events[i])
            copied.color = 'purpleblue' // it's a bit of a hack here, made for counting this event as both modified and new on server side
            eventsToConsider.push(copied)
          } else {
            eventsToConsider.push(this.events[i])
          }
        }
      }
      const eventsCount = eventsToConsider.length
      eventsToConsider.forEach(e => {
        if (!e.timed) {
          e.realEnd = this.getDateWithDayOffset(e.end, 1).slice(0, 10)
          e.start = e.start.slice(0, 10)
        } else {
          e.realEnd = e.end
        }
      })
      this.axios
        .post('/api/submit-transmission/', eventsToConsider, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        })
        .then((response) => {
          if (response) {
            this.transferData(true, eventsCount)
          }
        })
        .catch((error) => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
          this.isLoading = false
        })
    },
    onClickSelectedDate (event) {
      this.sortDates(event.eventDates)
      event.start = event.eventDates[0]
      event.end = event.eventDates.length === 1 ? event.eventDates[0] : event.eventDates[1]
      this.menuSelected = false
      this.checkForChanges(event)
      this.updateKey++
    },
    checkForChanges (event) {
      const originalEvent = this.originalEvents.filter(
        (item) => item.eventId === event.eventId
      )[0]
      let same = true
      for (const key in originalEvent) {
        if (['color', 'eventId', 'eventDates'].indexOf(key) > -1) continue
        same = originalEvent[key] === event[key]
        if (!same) break
      }
      if (same) event.color = originalEvent.color
      else event.color = 'purple'
    },
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor (event) {
      return event.color
    },
    setToday () {
      this.focus = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        setTimeout(() => {
          this.selectedOpen = true
        }, 10)
      }
      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }
      nativeEvent.stopPropagation()
    },
    convertDateToString (d, timeZone = 'UTC') {
      let date
      if (timeZone === 'UTC') {
        date = new Date(d)
          .toLocaleString('en-US', { hour12: false })
          .split(' ')
      } else {
        date = new Date(d)
          .toLocaleString('en-US', { timeZone: timeZone, hour12: false })
          .split(' ')
      }
      const time = date[1]
      let mdy = date[0]
      mdy = mdy.split('/')
      let month = parseInt(mdy[0])
      let day = parseInt(mdy[1])
      let year = parseInt(mdy[2])
      if (year < 10) year = '0' + year.toString()
      if (month < 10) month = '0' + month.toString()
      if (day < 10) day = '0' + day.toString()
      return year + '-' + month + '-' + day + ' ' + time
    },
    getDateWithDayOffset (dateString, offset) {
      const d = new Date(dateString)
      d.setDate(d.getDate() + offset)
      return this.convertDateToString(d, 'Europe/Kiev')
    },
    onChangeEvent (event) {
      event.color = 'purple'
    },
    sortDates (val) {
      if (val.length === 2) {
        if (val[0] > val[1]) {
          var t = val[0]
          val[0] = val[1]
          val[1] = t
        }
      }
    },
    addEventsToCalendar (events) {
      const newEvents = []
      for (const event of events) {
        const end = event.end.length > 10 ? event.end : this.getDateWithDayOffset(event.end, -1).slice(0, 10) // the only transmission that should left
        const eventDates = event.timed ? [] : [event.start, end]
        newEvents.push({
          name: event.name,
          start: event.start,
          end: end,
          eventDates: eventDates,
          color: event.color,
          timed: event.timed,
          eventId: event.eventId,
          employeeLogin: event.employeeLogin
        })
      }
      this.originalEvents = newEvents
      for (let i = 0; i < this.originalEvents.length; i++) {
        const obj = Object.assign({}, this.originalEvents[i])
        this.$set(this.events, i, obj)
      }
      this.updateKey++
    },
    okButtonClicked () {
      this.menu = false
    },
    transferData (showSuccessMessage = false, transferredEventsCount = 0) {
      this.isLoading = true
      this.axios.post(
        '/api/transfer-absence',
        {
          sickLeavesMode: this.sickLeavesMode,
          dateFrom: this.dates[0],
          dateTo: this.dates[1]
        },
        {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }
      ).then((response) => {
        this.events = []
        this.addEventsToCalendar(response.data)
        this.dataRetrieved = true
        if (showSuccessMessage) {
          const successCount = response.data.filter(e => e.color === 'green').length
          const absenceType = this.sickLeavesMode ? 'sick leave' : 'vacation'
          let message = ''
          if (transferredEventsCount > 0) {
            message = `Successfully transferred ${transferredEventsCount} ${absenceType} event(s) to DCM`
            if (successCount < transferredEventsCount) {
              const failedCount = transferredEventsCount - successCount
              message += ` (${failedCount} failed - check logs and retry)`
            }
          } else {
            message = `${absenceType.charAt(0).toUpperCase() + absenceType.slice(1)} events transfer completed`
          }
          this.$store.dispatch('setSuccess', { successMsg: message })
        }
      }).catch((error) => {
        const serverMsg = error && error.response && error.response.data
        this.$store.dispatch('setError', {
          errorMsg: (error.message || 'Request failed') + (serverMsg ? ' - ' + serverMsg : '')
        })
      }).finally(() => {
        this.isLoading = false
      })
    },
    getDateWithMonthOffset (offset) {
      const d = new Date(formatLocalDate(this.date))
      d.setMonth(d.getMonth() + offset)
      return formatLocalDate(d)
    },
    getClosedSummaryState () {
      const absenceType = this.sickLeavesMode ? 'sick-leave' : 'vacation'
      const body = {
        From_Date: this.dates[0],
        To_Date: this.dates[1],
        Absence_Type: absenceType
      }
      this.axios.post('/api/absence-summary', body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        if (res.data[0]) {
          this.lastSummaryDates = []
          this.lastSummaryDates = res.data
          this.showWarningDialog = true
        } else {
          this.showDialog = true
        }
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    createNewTasks () {
      const currentMonth = new Date().getMonth()
      if (currentMonth === 11) {
        this.dateForAbsenceAndSickLeaveTasks = new Date().getFullYear() + 1
      } else if (currentMonth === 0) {
        this.dateForAbsenceAndSickLeaveTasks = new Date().getFullYear()
      }
      const body = {
        Date: this.dateForAbsenceAndSickLeaveTasks + '-01-01'
      }
      this.axios.post('/api/absence/newtasksforyear', body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setSuccess', { successMsg: 'New tasks successfully created' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  },
  watch: {
    dates (val) {
      this.sortDates(val)
    }
  }
}
</script>
<style lang="scss">
  .v-calendar-daily__head {
    max-height: 300px;
    overflow-y: scroll;
    width: 100%;
    border:1px;
  }

  .c-outer-div {
    position: relative;
  }
</style>
